"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRangeFromIndexedConnector = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * Provides the AABB (in data space) of an indexed point connector. The last parameter is an optional out parameter, if
 * not supplied F64 will be assumed.
 */
function getRangeFromIndexedConnector(connector, result = new rc_js_util_1.Range1d.f64()) {
    const sizeOffset = connector.offsets.size;
    if (sizeOffset == null) {
        return null;
    }
    for (let i = connector.getStart(), iEnd = connector.getEnd(); i < iEnd; ++i) {
        result.extendRange(connector.getValue(i, sizeOffset), result);
    }
    return result;
}
exports.getRangeFromIndexedConnector = getRangeFromIndexedConnector;
//# sourceMappingURL=get-range-from-indexed-connector.js.map